const SVG_NS = "http://www.w3.org/2000/svg";

export interface MotifOptions {
  readonly size?: number;
}

export function createMotif(opts: MotifOptions = {}): SVGSVGElement {
  const size = opts.size ?? 16;
  const svg = document.createElementNS(SVG_NS, "svg");
  svg.setAttribute("width", String(size * 2));
  svg.setAttribute("height", String(size));
  svg.setAttribute("viewBox", "0 0 32 16");
  svg.style.display = "block";

  const g = document.createElementNS(SVG_NS, "g");
  g.setAttribute("stroke", "var(--brass)");
  g.setAttribute("stroke-width", "1");
  g.setAttribute("fill", "none");

  // viewBox is 0–32; center the ring + plus at x=16 so the whole crest is
  // symmetric. Previous layout had the ring at x=14, drifting the motif to
  // the left of its container.
  const lines = [
    "M0 8 L11 8",
    "M16 5 L16 11 M13 8 L19 8",
    "M21 8 L32 8",
  ];
  for (const d of lines) {
    const p = document.createElementNS(SVG_NS, "path");
    p.setAttribute("d", d);
    g.appendChild(p);
  }
  const ring = document.createElementNS(SVG_NS, "circle");
  ring.setAttribute("cx", "16");
  ring.setAttribute("cy", "8");
  ring.setAttribute("r", "3");
  g.appendChild(ring);
  const dot = document.createElementNS(SVG_NS, "circle");
  dot.setAttribute("cx", "16");
  dot.setAttribute("cy", "8");
  dot.setAttribute("r", "1");
  dot.setAttribute("fill", "var(--brass)");
  dot.setAttribute("stroke", "none");
  g.appendChild(dot);

  svg.appendChild(g);
  return svg;
}

export function createMotifWrap(opts: MotifOptions = {}): HTMLElement {
  const wrap = document.createElement("div");
  wrap.className = "motif";
  wrap.appendChild(createMotif(opts));
  return wrap;
}
